<div class="youtube-player-container">
  @let type = resourceType();
  @let id = resourceId();
  @if (type === "video") {
    <youtube-player
      [videoId]="id"
      [placeholderImageQuality]="placeholderImageQuality()"
      [placeholderWebpImage]="placeholderWebpImage()"
      [placeholderPriority]="placeholderPriority()"
      [playerVars]="_playerVars()"
    />
  } @else if (type === "playlist") {
    <youtube-player
      [playerVars]="{ list: id }"
      [playlistPlaceholderVideoId]="playlistPlaceholderVideoId()"
      [placeholderImageQuality]="placeholderImageQuality()"
      [placeholderWebpImage]="placeholderWebpImage()"
      [placeholderPriority]="placeholderPriority()"
      [playerVars]="_playerVars()"
    />
  }
</div>
